// extracted by mini-css-extract-plugin
module.exports = {"container":"AddXpPoints_container__1AW7F"};